import axios from 'axios';
import { Common } from '../common';

import {
  FilterOptions,
  Finding,
  UpdateFindingValues,
} from '../models/patient/finding';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options: FilterOptions): Promise<Finding[]> {
    const url = this.common.constructPath(`/patient-findings`, options);
    return this.common.getJSON(url);
  }

  async get(findingId: string): Promise<Finding> {
    const url = this.common.constructPath(`/patient-findings/${findingId}`);
    return this.common.getJSON(url);
  }

  async update(
    findingId: string,
    values: UpdateFindingValues,
  ): Promise<Finding> {
    const url = this.common.constructPath(`/patient-findings/${findingId}`);
    return this.common.patchJSON(url, values);
  }

  async upload(formData: FormData) {
    const url = this.common.constructPath(`/patient-findings/upload`);
    return axios.put(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
  }
}
